import { render, staticRenderFns } from "./LoyaltyConfigForm.vue?vue&type=template&id=33ed4498&scoped=true&"
import script from "./LoyaltyConfigForm.vue?vue&type=script&lang=ts&"
export * from "./LoyaltyConfigForm.vue?vue&type=script&lang=ts&"
import style0 from "./LoyaltyConfigForm.vue?vue&type=style&index=0&id=33ed4498&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ed4498",
  null
  
)

export default component.exports